import { http } from '../../config/axios'

 const graficoConsumoClient = (): Promise<any> => {
  
  return http
    .get('api/consumo/graficobyclient/')
    .then((res:any) => {
      return res.data as any
    })
    .catch((error:any) => {
      console.error('Erro graficoConsumoClient', error)
      throw Error(error.response.data)
    })
}

export default graficoConsumoClient;
